import { FC } from "react";
import Chip from "@mui/material/Chip";
import { LastExecution } from "@/services/cloudchipr.api";
import {
  lastExecutionChipColor,
  lastExecutionStateIcon,
} from "@/components/pages/automations/workflows/data-grid/components/columns/last-execution-cell/utils/constants/constants";

interface WorkflowLastExecutionStatusChipProps {
  status: LastExecution["status"];
  count: number;
}

export const WorkflowLastExecutionStatusChip: FC<
  WorkflowLastExecutionStatusChipProps
> = ({ status, count }) => {
  if (!count) {
    return null;
  }

  return (
    <Chip
      size="small"
      variant="outlined"
      label={count}
      sx={{ color: status === "skipped" ? "text.secondary" : undefined }}
      color={lastExecutionChipColor.get(status)}
      icon={lastExecutionStateIcon.get(status)}
    />
  );
};
